import BuildCard from '@/components/build/build-card';
import { Spinner } from '@/components/ui/spinner';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import type { IBuild } from '@/entities/build.entity';
import { HistoryIcon } from 'lucide-react';

interface MyBuildsSectionProps {
	builds: IBuild[];
	loading: boolean;
	onCancel?: () => void;
	onInstalled?: () => void;
}

export default function MyBuildsSection({ builds, loading, onCancel, onInstalled }: MyBuildsSectionProps) {
	return (
		<Card className='gap-0 py-0 shadow-sm overflow-hidden'>
			<CardHeader className='border-b px-4 py-4 flex'>
				<div className='flex items-center gap-3'>
					<div className='rounded-lg bg-chart-2/15 p-2'>
						<HistoryIcon className='text-chart-2' size={20} />
					</div>
					<div>
						<CardTitle className='text-chart-2'>Мои билды</CardTitle>
						<CardDescription>История сборок и скачивание готовых APK</CardDescription>
					</div>
				</div>
			</CardHeader>

			<CardContent className='px-4 py-4'>
				{loading ? (
					<div className='flex justify-center py-8'>
						<Spinner />
					</div>
				) : builds.length === 0 ? (
					<div className='text-center text-sm text-muted-foreground py-8'>Билдов пока нет</div>
				) : (
					<div className='flex flex-col gap-3'>
						{builds.map(build => (
							<BuildCard key={build.id} build={build} onCancel={onCancel} onInstalled={onInstalled} />
						))}
					</div>
				)}
			</CardContent>
		</Card>
	);
}
